import { Box, Typography } from "@mui/material";
import { useImageObjectUrl } from "Hooks/useImageObjectUrl";

type Props = {
  file: File;
  height?: number;
};

/** Thumbnail of an image file; other files (PDF) show their name. */
export const FilePreview = ({ file, height = 72 }: Props) => {
  const url = useImageObjectUrl(file);

  if (!url) {
    return (
      <Typography fontSize={12} noWrap>
        {file.name}
      </Typography>
    );
  }

  return (
    <Box
      component="img"
      src={url}
      alt={file.name}
      sx={{ height, maxWidth: "100%", objectFit: "contain", borderRadius: 1 }}
    />
  );
};
